import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft, Waves, ChefHat } from "lucide-react";
import { Link } from "react-router-dom";
const Menu = () => {
  const menuSections = [{
    title: "SALADES ET PETITS PLATS",
    items: [{
      name: "Salade au chèvre chaud et jambon de Pays",
      description: "Servi avec œuf, toast et tomates, une petite touche de miel sur le fromage de chèvre",
      price: "19€"
    }, {
      name: "Salade César",
      description: "Poulet, parmesan, œuf, tomates, croûtons, noix, vinaigre balsamique",
      price: "19€"
    }, {
      name: "Cocktail de crevettes",
      description: "12 pièces avec aïoli",
      price: "19€"
    }, {
      name: "Salade de gésiers et magret de canard fumé",
      description: "Œuf dur, tomates, croûtons et noix",
      price: "19€"
    }]
  }, {
    title: "FRUITS DE MER",
    items: [{
      name: "6 Huîtres",
      description: "Huîtres fraîches",
      price: "14€"
    }, {
      name: "12 Huîtres",
      description: "Huîtres fraîches",
      price: "22€"
    }, {
      name: "Assiette de fruits de mer persillade",
      description: "4 Huîtres, 6 crevettes 30/50 et 10 moules cuites",
      price: "21€"
    }, {
      name: "6 Huîtres gratinées à l'ail",
      description: "Huîtres gratinées",
      price: "17€"
    }, {
      name: "12 Moules gratinées à l'ail",
      description: "Moules gratinées",
      price: "15€"
    }]
  }, {
    title: "POISSONS A LA PLANCHA",
    items: [{
      name: "Filet de Loup de mer",
      description: "Sauce avec chorizo",
      price: "25€"
    }, {
      name: "Gambas flambées au Pastis ou au Whisky",
      description: "5 pièces mini",
      price: "27€"
    }, {
      name: "Gambas à la plancha",
      description: "Gambas grillées",
      price: "26€"
    }, {
      name: "Seiche en persillade",
      description: "3 pièces",
      price: "24€"
    }, {
      name: "Pavé de saumon à l'aneth",
      description: "Saumon frais aux herbes",
      price: "26€"
    }, {
      name: "Filet de St Pierre",
      description: "Sauce citronnée",
      price: "26€"
    }, {
      name: "Parillada",
      description: "Filet de Loup, de ST Pierre, seiches, moules et crevettes",
      price: "32€"
    }]
  }, {
    title: "MOULES FRITES",
    items: [{
      name: "Moules Marinière",
      description: "Vin blanc, échalotes, persil",
      price: "16€"
    }, {
      name: "Moules Crème",
      description: "Crème fraîche et fines herbes",
      price: "17€"
    }, {
      name: "Moules Roquefort",
      description: "Sauce au roquefort",
      price: "18€"
    }]
  }, {
    title: "LES PATES",
    items: [{
      name: "Linguini à la Carbonara",
      description: "Pâtes fraîches, lardons, crème, parmesan",
      price: "17€"
    }, {
      name: "Linguini aux fruits de mer",
      description: "Pâtes fraîches aux fruits de mer",
      price: "21€"
    }]
  }, {
    title: "VIANDES",
    description: "Accompagnement : Riz ou Frites ou Légumes ou Spatzle",
    items: [{
      name: "Entrecôte nature",
      description: "Viande de bœuf grillée",
      price: "25€"
    }, {
      name: "Entrecôte Forestière",
      description: "Aux champignons",
      price: "28€"
    }, {
      name: "Entrecôte poivre vert",
      description: "Sauce au poivre vert",
      price: "28€"
    }, {
      name: "Entrecôte échalotes",
      description: "Sauce aux échalotes",
      price: "28€"
    }, {
      name: "Onglet de bœuf à l'échalote",
      description: "Pièce de bœuf aux échalotes",
      price: "25€"
    }, {
      name: "Escalope de veau à la crème",
      description: "Escalope de veau, sauce crème",
      price: "26€"
    }, {
      name: "Escalope de veau Milanaise",
      description: "Escalope panée",
      price: "26€"
    }, {
      name: "Cordon bleu de veau pané",
      description: "Veau, jambon, fromage, pané",
      price: "27€"
    }, {
      name: "Cordon bleu de veau à la crème",
      description: "Veau, jambon, fromage, sauce crème",
      price: "29€"
    }]
  }, {
    title: "BURGERS",
    description: "Sauce au choix Ketchup, Mayonnaise, sauce burger",
    items: [{
      name: "CHEESE BURGER",
      description: "Fromage, steak haché 170grs",
      price: "16€"
    }, {
      name: "BACON BURGER",
      description: "Fromage, steak haché 170grs, tomate, oignons, bacon",
      price: "17€"
    }]
  }, {
    title: "MENU DU MIDI",
    description: "Servi tous les midis de la semaine sauf le dimanche",
    items: [{
      name: "Formule Entrée + Plat",
      description: "Au choix dans notre sélection",
      price: "19€"
    }, {
      name: "Formule Plat + Dessert",
      description: "Au choix dans notre sélection",
      price: "19€"
    }, {
      name: "Formule complète",
      description: "Entrée + Plat + Dessert",
      price: "24€"
    }]
  }, {
    title: "MENU ENFANT",
    description: "Jusqu'à 9 ans",
    items: [{
      name: "Hamburger",
      description: "Steak 110 grs + dessert",
      price: "12€"
    }, {
      name: "Pâtes Carbonara",
      description: "Pâtes + dessert",
      price: "12€"
    }]
  }];
  return <div className="min-h-screen bg-background">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm z-50 shadow-wave">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-2">
              <ArrowLeft className="h-6 w-6 text-primary" />
              <img src="./images/Logo restaurant .jpeg" alt="Logo La Baleine Bleue" className="h-10 w-10 object-contain" />
              <h1 className="text-2xl font-bold text-primary">La Baleine Bleue</h1>
            </Link>
            <div className="flex space-x-3 md:space-x-6 text-sm md:text-base">
              <Link to="/" className="text-foreground hover:text-primary transition-smooth">Accueil</Link>
              <Link to="/menu" className="text-primary font-medium">Menu</Link>
              <Link to="/about" className="text-foreground hover:text-primary transition-smooth">À propos</Link>
              <Link to="/contact" className="text-foreground hover:text-primary transition-smooth">Contact</Link>
            </div>
            <Button className="ocean-gradient text-white shadow-ocean hover:shadow-wave transition-wave">
              Réserver
            </Button>
          </div>
        </div>
      </nav>

      {/* Header */}
      <section className="pt-24 pb-12 wave-gradient">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <Badge className="mb-6 ocean-gradient text-white border-0">
              <ChefHat className="mr-2 h-4 w-4" />
              Notre Carte
            </Badge>
            <h1 className="text-5xl font-bold mb-6 text-foreground">
              Menu La Baleine Bleue
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Découvrez notre sélection de plats spécialisés en choucroute de la mer et cordon bleu par le Chef Philippe Lung
            </p>
          </div>
        </div>
      </section>

      {/* Menu Images */}
      <section className="py-12 bg-background">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            <img src="./images/Carte 1 .jpeg" alt="Menu 1" className="rounded-lg shadow-elegant hover:shadow-ocean transition-wave" />
            <img src="./images/Carte 2 .jpeg" alt="Menu 2" className="rounded-lg shadow-elegant hover:shadow-ocean transition-wave" />
            <img src="./images/Carte 3.jpeg" alt="Menu 3" className="rounded-lg shadow-elegant hover:shadow-ocean transition-wave" />
            <img src="./images/Carte 4 Midi .jpeg" alt="Menu 4" className="rounded-lg shadow-elegant hover:shadow-ocean transition-wave" />
          </div>
        </div>
      </section>

      {/* Menu Sections */}
      <section className="pb-20">
        <div className="container mx-auto px-4">
          <div className="space-y-12">
            {menuSections.map((section, index) => <Card key={index} className="shadow-elegant border-0 overflow-hidden">
                <CardHeader className="ocean-gradient text-white">
                  <CardTitle className="text-2xl font-bold flex items-center">
                    <img src="./images/Logo restaurant .jpeg" alt="Logo" className="mr-3 h-6 w-6 object-contain" />
                    {section.title}
                  </CardTitle>
                  {section.description && <p className="text-white/90 text-sm">{section.description}</p>}
                </CardHeader>
                <CardContent className="p-6">
                  <div className="grid gap-6">
                    {section.items.map((item, itemIndex) => <div key={itemIndex} className="flex justify-between items-start border-b border-border pb-4 last:border-0 last:pb-0">
                        <div className="flex-1">
                          <h3 className="font-semibold text-foreground mb-1">{item.name}</h3>
                          <p className="text-muted-foreground text-sm">{item.description}</p>
                        </div>
                        <div className="ml-4 text-right">
                          <span className="text-xl font-bold text-primary">{item.price}</span>
                        </div>
                      </div>)}
                  </div>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 wave-gradient">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h2 className="text-4xl font-bold mb-6 text-foreground">
              Prêt à déguster ?
            </h2>
            <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
              Réservez votre table dès maintenant et laissez-vous emporter par les saveurs de la mer
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button size="lg" className="ocean-gradient text-white shadow-ocean hover:shadow-wave transition-wave">
                Réserver une table
              </Button>
              <Link to="/">
                <Button size="lg" variant="outline" className="border-primary text-primary hover:bg-primary hover:text-white transition-wave">
                  Retour à l'accueil
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-primary text-white py-12">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div className="flex items-center justify-center space-x-2 mb-4">
              <h3 className="text-2xl font-bold">La Baleine Bleue</h3>
            </div>
            <p className="text-white/80 mb-6">
              Restaurant La Baleine Bleue • Chef Philippe Lung • Saint Pierre La Mer
            </p>
            <div className="flex justify-center space-x-6">
              <a href="#" className="text-white/80 hover:text-white transition-smooth">Facebook</a>
              
              <a href="#" className="text-white/80 hover:text-white transition-smooth">TripAdvisor</a>
            </div>
            <div className="mt-8 pt-8 border-t border-white/20">
              <p className="text-white/60 text-sm">
                © 2024 La Baleine Bleue. Tous droits réservés.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>;
};
export default Menu;